import React, { Component } from 'react'
import { connect } from 'react-redux'

// API
import * as API  from '../../../utils/api'

// Packages
import { Helmet } from 'react-helmet'

// Actions
import {
  getProfileAccountDetails
} from '../../../actions/accountDetails'

import {
  getUpdatedUser
} from '../../../actions/user'

import {
  setCurrentParticipation,
  updateCurrentParticipation,
} from '../../../actions/locker'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import LockerNav from '../../../components/UserPortal/Locker/LockerNav'
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader'

// Child Screens
import LockerProfile from './LockerScreens/LockerProfile'
import LockerPhotoVideo from './LockerScreens/LockerPhotoVideo'
import LockerAwards from './LockerScreens/LockerAwards'
import LockerStats from './LockerScreens/LockerStats'
import LockerCamps from './LockerScreens/LockerCamps'
import LockerContact from './LockerScreens/LockerContact'

// Helpers
import { toTitleCase } from '../../../utils/helpers'

import sportAndImageNames from '../../../utils/data/sportAndImageNames'

const heroImageFilenames = sportAndImageNames.reduce((accumulator, data) => {
  accumulator[data.sportName] = data.imageName
  return accumulator
}, {})

class LockerPortal extends Component {

  state = {
    profile: '',
    activeProfileUsername: '',
    heroImages: null,
    currentParticipation: null,
    pageTitle: 'Locker',
    isLoading: true,
    participationIsLoading: true,
  }

  componentDidMount() {
    this.initializeLockerPortalState()
    this.updateCurrentParticipation(this.props)
    this.importHeroImages(
      require.context('../../../assets/images/hero-backgrounds', false, /\.(png|jpe?g|svg)$/)
    )
    this.setPageTitle(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setPageTitle(nextProps)
    this.updateCurrentParticipation(nextProps)

    if (nextProps.activeProfile.username !== this.props.activeProfile.username) {
      this.setState({
        isLoading: true
      }, () => this.reInitializeLockerPortalState())
    }
  }

  importHeroImages(route) {
    let images = {}
    route.keys().map((item, index) => {
      return images[item.replace('./', '')] = route(item)
    })

    this.setState({ heroImages: images })
  }

  getHeroImagePath = () => {
    const { heroImages } = this.state
    const { currentParticipation } = this.state

    const filename = currentParticipation ? heroImageFilenames[currentParticipation.sport.name] : 'football.jpg'
    return heroImages[filename]
  }

  initializeLockerPortalState() {
    // Get sport and section params from url
    // to determine initial path
    const sport = this.props.match.params.sport
    const section = this.props.match.params.section
    const { username } = this.props.activeProfile

    // Store player profile data for use in LockerNav tabs
    API.getProfile(username)
    .then(profile => {
      let sportSlug = profile.participations[0].sport_slug

      this.setState(({
        profile,
        activeProfileUsername: username,
        isLoading: false
      }), this.redirectToUrl(sport ? sport : sportSlug, section ? section : 'profile'))
    })
  }

  reInitializeLockerPortalState() {
    const { username } = this.props.activeProfile

    // Store player profile data for use in LockerNav tabs
    API.getProfile(username)
    .then(profile => {
      let sportSlug = profile.participations[0].sport_slug

      this.setState(({
        profile,
        activeProfileUsername: username,
        isLoading: false
      }), this.redirectToUrl(sportSlug, 'profile'))
    })
  }

  updateCurrentParticipation(props) {
    const { sport } = props.match.params
    const { participations } = props.activeProfile

    let currentParticipation = participations ? participations.filter((participation) => {
      return participation.sport_slug === sport
    }) : []

    if (currentParticipation.length > 0) {
      API.getParticipation(currentParticipation[0].id)
      .then(participation => {
        this.setState({
          currentParticipation: participation,
          participationIsLoading: false
        })
      })
    }
  }

  setPageTitle(props) {
    const { section } = props.match.params
    const { currentParticipation } = this.state

    let sportName = currentParticipation ? currentParticipation.sport.name + ' – ' : ''
    let sectionName = 'Locker'

    if (section && (section === 'photos-videos')) {
      sectionName = 'Photos & Video'
    } else if (section) {
      sectionName = toTitleCase(section)
    }

    let pageTitle = sportName + sectionName

    this.setState({ pageTitle })
  }

  switchAthlete(props) {
    const { activeProfileUsername } = this.state
    const { username } = props.activeProfile

    if (activeProfileUsername !== '' && activeProfileUsername !== username) {
      API.getProfile(username)
      .then(profile => {
        let sportSlug = profile.participations[0].sport_slug

        this.setState(({
          profile,
          activeProfileUsername: username,
          isLoading: false
        }), this.redirectToUrl(sportSlug, 'profile'))
      })
    }
  }

  redirectToUrl(sport, section) {
    this.props.history.push(`/locker/${sport}/${section}`)
  }

  getSectionTitle(section) {
    switch(section) {
      case 'photos-videos':
        return 'Photos & Video'
        // eslint-disable-next-line no-unreachable
        break
      default:
        return toTitleCase(section)
    }
  }

  refreshParticipation = () => (
    new Promise((resolve, reject) => {
      const { id } = this.state.currentParticipation

      API.getParticipation(id)
      .then(participation => {
        this.setState({ currentParticipation: participation }, resolve)
      })
    })
  )

  renderLockerFormComponent(section) {
    const { currentParticipation, participationIsLoading } = this.state

    switch(section) {
      case 'profile':
        return <LockerProfile
          participation={currentParticipation}
          isLoading={participationIsLoading}
          updateParticipation={this.refreshParticipation}
        />
        // eslint-disable-next-line no-unreachable
        break
      case 'photos-videos':
        return <LockerPhotoVideo
          updateParticipation={this.refreshParticipation}
          participation={currentParticipation}
          isLoading={participationIsLoading}
        />
        // eslint-disable-next-line no-unreachable
        break
      case 'awards':
        return <LockerAwards
          participation={currentParticipation}
          isLoading={participationIsLoading}
        />
        // eslint-disable-next-line no-unreachable
        break
      case 'stats':
        return <LockerStats
          participation={currentParticipation}
          updateParticipation={this.refreshParticipation}
        />
        // eslint-disable-next-line no-unreachable
        break
      case 'camps':
        return <LockerCamps participation={currentParticipation}/>
        // eslint-disable-next-line no-unreachable
        break
      case 'contact':
        return <LockerContact participation={currentParticipation}/>
        // eslint-disable-next-line no-unreachable
        break
      default:
        return null
    }
  }

  render() {
    const {
      path,
      appName
    } = this.props

    const {
      section,
      sport
    } = this.props.match.params

    const {
      profile,
      isLoading,
      pageTitle,
    } = this.state

    return (
      <div className="user-portal locker-portal">
        <Helmet>
          <title>{pageTitle} | {appName}</title>
        </Helmet>
        <Header path={ path } />
        {
          isLoading
          ? (
            <div className="locker-portal-inner loading">
              <AppCanvasLoader />
            </div>
          )
          : (
            <div className="locker-portal-inner">
              <div className="locker-portal-inner-content">
                <LockerNav
                  currentSport={sport}
                  currentSection={section}
                  playerProfile={profile}
                />
                {this.renderLockerFormComponent(section)}
              </div>
              <div
                className="locker-portal-inner-background"
                style={ {backgroundImage: `url(${this.getHeroImagePath()})`} }
              />
            </div>
          )
        }
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProfileAccountDetails: (user, athleteUsername) => {
      dispatch(getProfileAccountDetails(user, athleteUsername))
    },
    getUpdatedUser: (user) => {
      dispatch(getUpdatedUser(user))
    },
    setCurrentParticipation: (participationId) => dispatch(setCurrentParticipation(participationId)),
    updateCurrentParticipation: (participationId) => dispatch(updateCurrentParticipation(participationId)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LockerPortal)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerPortal.js